import React from 'react';

import { Heading } from 'Modules/ui';

import styles from './index.module.scss';


export const ListPlaceholder = ({ header }) => (
    <div className={styles.listPlaceholder}>
        <div className={styles.header}>
            <Heading
                component='div'
                headingType='h1Element'
                className={styles.heading}
            >
                {header}
            </Heading>
        </div>
        <div className={styles.tableLikeHeader} />
    </div>
);
